// Localisable strings that come from DATA (rooms.json / the portal's stored
// config) rather than from the message catalogue — room names, variant names,
// hotspot labels, narration.
//
// The union with plain `string` is what makes this migration free: every
// existing rooms.json, all six shipped demos and every config already stored in
// the portal keep working untouched, and a bare string is read as pt-BR.
// Localisation becomes opt-in, per field.
//
//   "Sala de Estar"                                  → pt-BR only
//   { "pt-BR": "Sala de Estar", "en": "Living room" } → both
//
// The portal already holds `name_pt` / `name_en` columns and name-rooms.mjs
// already asks the vision model for both, so the object form costs no new data
// entry — see server/actions/tours.ts in imersivo-studio.

import { DEFAULT_LOCALE, type Locale } from './index.ts';

export type LocalizedString = string | ({ 'pt-BR': string } & Partial<Record<Locale, string>>);

export function localize(value: LocalizedString | undefined, locale: Locale): string {
  if (value === undefined) return '';
  if (typeof value === 'string') return value;
  return value[locale] ?? value[DEFAULT_LOCALE] ?? '';
}

/** True when the value carries a translation for `locale` specifically. */
export function hasTranslation(value: LocalizedString | undefined, locale: Locale): boolean {
  if (value === undefined) return false;
  if (typeof value === 'string') return locale === DEFAULT_LOCALE;
  return typeof value[locale] === 'string' && value[locale] !== '';
}
